import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Department } from '@app/models';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';

const API = environment.API;

@Injectable({
	providedIn: 'root'
})
export class DepartmentService {
	constructor(
		private http: HttpClient,
		private store: Store<any>
	) { }

	get() {
		return this.http.get<Department[]>(`${API}departments`);
	}

	downloadDep(depId){
		return this.http.get(`${API}departments/${depId}/download`)
	}

	getDepartmentImportLink(file, departmentId, upsertType){
		const mimeType = file.type;
    const name = file.name;
    const DeparmentId = departmentId

		return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      DeparmentId,
			FileableType: upsertType
    });
	}

	uploadFile(link, file){
		return this.http.put<any>(`${link}`, file);
	}

	notifyFileUpload(id, metadata?) {
    const { processType } = metadata;

    return this.http.put<File>(
      `${API}files/${id}?processType=${processType || null}`,
      {
        status: 1,
      }
    );
  }

	getByConditions(FollowId, dataConditions?) {
		return this.http.get<Department[]>(
			`${API}departments/reports/showroom_department?FollowId=${FollowId}${dataConditions.CountryId ? '&CountryId=' + dataConditions.CountryId : ''
			}${dataConditions.businessUnit
				? '&businessUnit=' + dataConditions.businessUnit
				: ''
			}${dataConditions.DestinationCenterId
				? '&DestinationCenterId=' + dataConditions.DestinationCenterId
				: ''
			}`
		);
	}

	create(data) {
		return this.http.post<Department>(`${API}departments`, data);
	}

	search(conditions, FollowId) {
		const data = [...conditions, { key: 'FollowId', value: FollowId }];

		return this.http.post<any>(
			`${API}departments/hierarchyPlannerSearch`,
			data
		);
	}

	update(id, data) {
		return this.http.put<Department>(`${API}departments/${id}`, data);
	}

	destroySingle(DepartmentId) {
		return this.http.delete<any>(`${API}departments/${DepartmentId}`);
	}


	getById(FollowId, dataConditions?) {
		return this.http.get<Department[]>(
			`${API}departments/reports/showroom_one_department?FollowId=${FollowId}${dataConditions.CountryId ? '&CountryId=' + dataConditions.CountryId : ''
			}${dataConditions.businessUnit
				? '&businessUnit=' + dataConditions.businessUnit
				: ''
			}${dataConditions.DestinationCenterId
				? '&DestinationCenterId=' + dataConditions.DestinationCenterId
				: ''
			}${dataConditions.CategoryId
				? '&CategoryId=' + dataConditions.CategoryId
				: ''
			}`
		);
	}

	updateHierarchy(){
		return this.http.get<any>(`${API}departments/validateHierarchy`);
	}
}
